import React, { useEffect, useState } from "react";
import { api, formatDetail } from "@/lib/api";
import { toast } from "sonner";
import { Globe, RefreshCw, CheckCircle2, CircleDashed } from "lucide-react";

export const DomainStatusCard = () => {
  const [info, setInfo] = useState(null);
  const [checking, setChecking] = useState(false);

  const load = () => api.get("/system/public-url").then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const check = async () => {
    setChecking(true);
    try {
      const { data } = await api.post("/system/public-url/check");
      await load();
      toast[data.live ? "success" : "info"](data.live ? "console.collationwatch.org is live — email links now use it" : "Console domain not serving the app yet — still using the fallback link base");
    } catch (e) { toast.error(formatDetail(e.response?.data?.detail) || "Check failed"); }
    finally { setChecking(false); }
  };

  if (!info) return null;
  const host = (u) => (u || "").replace(/^https?:\/\//, "");
  return (
    <div className="border border-white/10 mt-6 px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="domain-status-card">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-zinc-500"><Globe size={13}/>Console domain</div>
      <div className="flex items-center gap-2 text-xs" data-testid="domain-live-status">
        {info.console_live
          ? <><CheckCircle2 size={14} className="text-emerald-400"/><span className="text-emerald-300">{host(info.console_domain)} is live</span></>
          : <><CircleDashed size={14} className="text-amber-400"/><span className="text-amber-300">{host(info.console_domain) || "no console domain configured"} not live yet</span></>}
      </div>
      <div className="text-xs text-zinc-400" data-testid="email-link-base">Email links use: <span className="text-white font-mono">{host(info.public_url) || "—"}</span></div>
      <button onClick={check} disabled={checking} className="ml-auto text-xs text-zinc-400 hover:text-white flex items-center gap-1 disabled:opacity-50" data-testid="domain-check-btn">
        <RefreshCw size={12} className={checking ? "animate-spin" : ""}/>Check now
      </button>
      {!info.console_live && <div className="w-full text-[11px] text-zinc-500">Auto-checked every 30 min. To go live: link <span className="font-mono">{host(info.console_domain)}</span> in the Emergent Domains tab and add the CNAME (DNS-only) at your DNS provider.</div>}
    </div>
  );
};
